<div class="audio-transcribe-wrapper">
	<div class="audio-transcribe-wrapper__header">
		<ng-content select="[label]"></ng-content>

		<div class="audio-transcribe-wrapper__controls">
			@if (isRecording && hasReceivedAudio()) {
				<span class="audio-transcribe-wrapper__timer" [class.audio-transcribe-wrapper__timer--limit]="elapsedSeconds() >= 55">
					{{ formattedTime }} / {{ formattedMax }}
				</span>
			}

			<button
				class="audio-transcribe-wrapper__mic-btn"
				[class.audio-transcribe-wrapper__mic-btn--recording]="isRecording && hasReceivedAudio()"
				type="button"
				data-analytics="voice-record"
				[title]="isRecording ? 'Stop recording' : 'Record audio to transcribe'"
				[disabled]="disabled() || isRequesting || blockedByOther()"
				(mouseenter)="prewarm()"
				(focus)="prewarm()"
				(click)="toggle()"
			>
				@if (isRequesting) {
					<lb-loader size="small"></lb-loader>
				} @else if (isRecording) {
					<span class="audio-transcribe-wrapper__stop-icon"></span>
				} @else {
					<md-icon icon="untitled-ui/media/microphone-01"></md-icon>
				}
			</button>
		</div>
	</div>

	<ng-content></ng-content>

	@if (state() === 'error' && errorMessage()) {
		<span class="audio-transcribe-wrapper__error" role="alert">{{ errorMessage() }}</span>
	}
</div>
